"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, User } from "lucide-react"; // Added User icon
import { useAuth } from "../context/AuthContext"; // Assuming you have an AuthContext
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { trackHeaderTabClick } from "@/utils/eventTracking";

const navigationItems = [
  { to: `${import.meta.env.VITE_LANDING_PAGE_URL}/#features`, label: "Features" },
  { to: `${import.meta.env.VITE_LANDING_PAGE_URL}/#pricing`, label: "Pricing" },
  { to: `${import.meta.env.VITE_LANDING_PAGE_URL}/blogs`, label: "Blogs" },
];

interface LandingHeaderProps {
  showLoginButton?: boolean;
}

export function LandingHeader({ showLoginButton = true }: LandingHeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  const renderAuthButton = (isMobile: boolean) => (

    showLoginButton ? (
      isAuthenticated ? (
        <div className="flex items-center gap-2">
          <Link to="/profile?active=profile">
            {isMobile ? <p className="text-white">Profile</p> : <div className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-400 to-purple-600 flex items-center justify-center overflow-hidden">
              <User className="h-4 w-4 text-white" />
            </div>}
          </Link>
        </div>
      ) : (
        <Button
          variant="outline"
          className={cn(
            "bg-gradient-to-r from-blue-400 to-purple-600 text-white border-none hover:from-blue-500 hover:to-purple-700 transition-all duration-300",
            isMenuOpen && "w-full"
          )}
        >
          Login
        </Button>
      )
    ) : null
  );

  const renderNavigationItems = (isMobile = false) => (
    <ul className={cn(
      isMobile ? "flex flex-col space-y-4" : "flex items-center space-x-6"
    )}>
      {navigationItems.map(({ to, label }) => (
        <li key={to}>
          <Link
            to={to}
            className="text-gray-300 hover:text-white transition-colors"
            onClick={() => trackHeaderTabClick(label)}
          >
            {label}
          </Link>
        </li>
      ))}
      <li>
        {renderAuthButton(isMobile)}
      </li>
    </ul>
  );

  return (
    <header className="container mx-auto px-4 py-6 bg-gray-900">
      <div className="flex justify-between items-center">
        <Link to="/" className="cursor-pointer">
          <h1 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600">
            Instavault
          </h1>
        </Link>
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden text-white bg-transparent border-gray-400 selected:bg-transparent"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <Menu className="h-6 w-6" />
        </Button>
        <nav className="hidden md:block">
          {renderNavigationItems()}
        </nav>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden mt-4">
          {renderNavigationItems(true)}
        </div>
      )}
    </header>
  );
}
